import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Box, useMultiStyleConfig, Text} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import useDamImage from '../../../custom-hooks/use-dam-image'
import DynamicIcon from '../../dynamic-icon/DynamicIcon'

const KeyFeaturesCard = ({
    imageUrl,
    images,
    title,
    description,
    linkLabel,
    linkUrl,
    isSlider,
    isLinkAbsolute = false,
    iconId,
    // aspectRatio = null,
}) => {
    const styles = useMultiStyleConfig('KeyFeatures', {
        variant: isSlider ? 'slider' : 'default',
    })

    const damImage = useDamImage(images)

    const imageToUse = damImage.url || imageUrl

    const buttonProps = isLinkAbsolute
        ? {
              as: 'a',
              href: linkUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: linkUrl,
          }
    return (
        <Flex
            {...styles.card}
            backgroundImage={imageToUse ? `url(${imageToUse})` : undefined}
            backgroundSize="cover"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
        >
            <Flex {...styles.cardIconAlignment}>
                {/* decorative: the card title already names the feature */}
                <Button
                    as="span"
                    variant="icon-button-outline"
                    pointerEvents="none"
                    aria-hidden="true"
                    {...styles.cardIconContainer}
                >
                    <DynamicIcon iconId={iconId} {...styles.icon} />
                </Button>
            </Flex>

            <Flex {...styles.cardContent}>
                <Box {...styles.blur} />
                <Text as="h3" {...styles.cardTitle}>
                    {title}
                </Text>
                <Text as="p" {...styles.cardDescription}>
                    {description}
                </Text>
            </Flex>
            {linkUrl && linkLabel && (
                <Button
                    {...buttonProps}
                    variant="primary"
                    {...styles.cardButton}
                    data-testid="key-features-card-button"
                >
                    {linkLabel}
                </Button>
            )}
        </Flex>
    )
}

KeyFeaturesCard.propTypes = {
    isLinkAbsolute: PropTypes.bool,
    imageUrl: PropTypes.string,
    images: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    isSlider: PropTypes.bool,
    aspectRatio: PropTypes.string,
    animationDelay: PropTypes.number,
    iconId: PropTypes.string,
}

export default KeyFeaturesCard
